import React, { useState } from "react";
import Table from "../../../Table";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import Modal from "../../../modal";
import NoData from "../../../noData";
import { GoDotFill } from "react-icons/go";

const StoreTable = ({
  loading,
  usersData,
  setIsStoreOpen,
  isStoreOpen,
  closeStoreModal,
  openStoreModal,
  handleDeleteStore,
  lastElementRef,
  openUserEditModal,
}) => {
  const [visiblePasswords, setVisiblePasswords] = useState({});

  const togglePasswordVisibility = (id) => {
    setVisiblePasswords((prevState) => ({
      ...prevState,
      [id]: !prevState[id],
    }));
  };

  const tableHeading = {
    no: <div className="ml-2 text-center">No.</div>,
    name: <div className=" px-2">Name</div>,
    id: <div className="">Id</div>,
    email: <div className="">Email</div>,
    password: <div className="text-center">Password</div>,
    editDetail: <div className="mr-2 text-center"></div>,
  };

  const headData = Object.values(tableHeading);

  const bodyData = usersData?.map((e, index) => {
    const isPasswordVisible = visiblePasswords[e?._id];
    return {
      no: <div className="ml-2 text-center">{index + 1}</div>,
      name: (
        <div className=" px-2">
          {e?.store?.name ? e?.store?.name : e?.user?.name}
        </div>
      ),
      id: <div className="">{e?.id}</div>,
      email: <div className="">{e?.email}</div>,
      password: (
        <div className="flex items-center justify-center gap-2">
          <span>
            {isPasswordVisible
              ? e?.password
              : e?.password
                  .split("")
                  .map((char, index) => (
                    <GoDotFill
                      key={index}
                      className="inline-block text-[9px]"
                    />
                  ))}
          </span>
          {isPasswordVisible ? (
            <AiOutlineEye
              className="text-xl cursor-pointer"
              onClick={() => togglePasswordVisibility(e?._id)}
            />
          ) : (
            <AiOutlineEyeInvisible
              className="text-xl cursor-pointer"
              onClick={() => togglePasswordVisibility(e?._id)}
            />
          )}
        </div>
      ),
      editDetail: (
        <div className="mr-2  flex justify-center gap-5">
          <img
            onClick={() => openUserEditModal(e)}
            className="cursor-pointer"
            src="/images/pencilIcon.svg"
            alt=""
          />
          <img
            onClick={() => openStoreModal(e)}
            className="cursor-pointer"
            src="/images/deleteIcon.svg"
            alt=""
          />
        </div>
      ),
    };
  });

  return (
    <>
      {usersData?.length > 0 ? (
        <Table
          tableHeading={headData}
          tableData={bodyData}
          headingClass={"text-left"}
          lastElementRef={lastElementRef}
        />
      ) : (
        <NoData />
      )}
      <Modal
        loading={loading}
        modalWidth="w-1/3"
        isOpen={isStoreOpen}
        setIsOpen={setIsStoreOpen}
        openModal={openStoreModal}
        closeModal={closeStoreModal}
        handleBtn2={handleDeleteStore}
        imgSrc="/images/exclamationIcon.svg"
        title="Are You Sure?"
        btn1="Cancel"
        btn2="Delete"
        btnClass={"justify-end"}
        modalContent={
          <p className="text-lg font-medium">
            Deleting will permanently remove this Detail the system.
          </p>
        }
      />
    </>
  );
};

export default StoreTable;
